import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

type CardProps = {
  radius?: number;
  background?: string;
  children?: any;
  fillAvailable?: boolean;
  fullWidth?: boolean;
  danger?: boolean;
};

function Card({
  radius,
  background,
  children,
  fillAvailable,
  danger,
  fullWidth,
}: CardProps) {
  return (
    <Container
      fillAvailable={fillAvailable}
      radius={radius}
      background={background}
      danger={danger}
      fullWidth={fullWidth}
    >
      {children}
    </Container>
  );
}

export default Card;

Card.defaultProps = {
  radius: 4,
  background: '#fff',
};

const Container = styled('div')<CardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: ${(props: CardProps) => props.radius}px;
  background: ${(props: CardProps) => props.background};
  margin-top: 8px;
  flex: ${(props: CardProps) => (props.fillAvailable ? '1 auto' : '0 auto')};
  ${(props: CardProps) =>
    props.danger &&
    css`
      background: #fcefee;
      color: #e70d0d;
    `};
  @media (orientation: landscape) {
    width: calc(50% - 8px);
    margin-right: 8px;
    align-items: center;

    ${(props: CardProps) =>
      props.fullWidth &&
      css`
        width: 100%;
      `}
  }
`;
